import { FoodDataSource } from "@notemeal/graphql-types";
import { AU_LOCALE_CODE, GB_LOCALE_CODE, US_LOCALE_CODE, NZ_LOCALE_CODE } from "@notemeal/locale-utils";
const BASE_ALLOWLISTED_DATA_SOURCES = [
    FoodDataSource.bonAppetit,
    FoodDataSource.cbord,
    FoodDataSource.compass,
    FoodDataSource.manual,
    FoodDataSource.nutritionix,
    FoodDataSource.restaurant,
    FoodDataSource.sodexo,
];
const STAFF_FOOD_SOURCES = [FoodDataSource.manual, FoodDataSource.mccance, FoodDataSource.ausnut, FoodDataSource.usda];
const SOURCES_FOR_LOCALE_MAP = {
    [US_LOCALE_CODE]: [...BASE_ALLOWLISTED_DATA_SOURCES, FoodDataSource.usda],
    [GB_LOCALE_CODE]: [...BASE_ALLOWLISTED_DATA_SOURCES, FoodDataSource.mccance],
    [AU_LOCALE_CODE]: [...BASE_ALLOWLISTED_DATA_SOURCES, FoodDataSource.ausnut],
    [NZ_LOCALE_CODE]: [...BASE_ALLOWLISTED_DATA_SOURCES, FoodDataSource.ausnut],
};
export const getStaffFoodSources = () => {
    return STAFF_FOOD_SOURCES;
};
export const getStaffFoodSourcesForLocale = (localeCode) => {
    const localeSources = getFoodDataSourcesForLocale({ localeCode, isStaff: true });
    return getStaffFoodSources().filter(source => localeSources.includes(source));
};
export const getFoodDataSourcesForLocale = ({ localeCode, isStaff }) => {
    const localeSources = SOURCES_FOR_LOCALE_MAP[localeCode] ?? SOURCES_FOR_LOCALE_MAP[US_LOCALE_CODE];
    if (isStaff) {
        return [...BASE_ALLOWLISTED_DATA_SOURCES, FoodDataSource.mccance, FoodDataSource.ausnut, FoodDataSource.usda].filter(source => localeSources.includes(source));
    }
    else {
        return localeSources;
    }
};
export const getFoodSearchFiltersForOrgLocale = (localeCode) => {
    return {
        localeFilter: [localeCode],
        dataSourceFilter: getFoodDataSourcesForLocale({ localeCode, isStaff: false }),
    };
};
export const getDefaultFoodSearchFiltersForOrgLocale = (isStaff, localeCode) => {
    if (isStaff) {
        return {
            localeFilter: [],
            dataSourceFilter: [],
        };
    }
    return getFoodSearchFiltersForOrgLocale(localeCode);
};
//# sourceMappingURL=foodDataSources.js.map